import React from "react";
import { withTranslation } from "react-i18next";
import { Button, Image, Divider, Select } from "antd";
import { CloseOutlined } from '@ant-design/icons';
import styled from "styled-components";

import Text from "components/Text";
import * as Styled from '../../styled';
import Title from "components/Title";


const StyledBackToShopLink = styled(Text)`
  &:hover {
    color: #13a9c6 !important;
  }
`;

/**
 * Basket
 * @param {*} props 
 * @returns 
 */
const Basket = (props) => {

  const getPrice = (item) => {
    return item.support.public_price * item.quantity;
  }

  const getTotalPrice = () => {
    let count = 0;
    props.basket.forEach((line) => {
      count += getPrice(line);
      
      // Count options
      line.options.forEach((category) => {
        if (category.selectedOption !== null) {
          count += category.selectedOption.price * line.quantity;          
        }
      })
    })

    return count;
  }

  const handleChangeQuantity = (index, quantity) => {
    const newBasket = [...props.basket];
    newBasket[index].quantity = quantity;
    props.setBasket(newBasket)
  }

  const handleRemoveFromBasket = (index) => {
    const newBasket = [...props.basket].filter((it, i) => i !== index).map((it) => it)
    
    if (newBasket.length === 0) {
      props.setPaymentData(null);
    }

    props.setBasket(newBasket)
  }

  return (
    <>
      <Styled.OptionsSelector
        onClick={() => props.setView('default')}      
      >
        <Title style={{ marginBottom: 20, marginTop: -4 }} size={20}>Votre panier</Title>
      </Styled.OptionsSelector>

      {
        props.basket.length === 0 ? (
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <Text align="center" style={{ marginTop: 20 }} size={14}>Votre panier est vide</Text>
            {
              props.selectedMount ? (
                <Button 
                  type="primary" 
                  style={{ width: 'fit-content', margin: 'auto', marginTop: 20 }} 
                  onClick={() => {props.setView('default'); props.setDisplaySupportsModal(true)}}
                >
                  Choisir un support d'impression
                </Button>
              ) : (
                <Button 
                  type="primary" 
                  style={{ width: 'fit-content', margin: 'auto', marginTop: 20 }} 
                  onClick={() => {props.setView('default'); props.setDisplayUserMountsModal(true)}}
                >
                  Choisir un montage à imprimer
                </Button>
              )
            }
          </div>
        ) : (
          <div style={{ width: '90%', maxWidth: 500, margin: 'auto', marginTop: 20 }}>
            <StyledBackToShopLink 
              align="center" 
              style={{ marginTop: 20 }} 
              size={14} 
              color="#53b297" 
              underline 
              cursor="pointer" 
              onClick={() => props.setView('default')} 
              className="link-color"
            >
              Continuer mes achats
            </StyledBackToShopLink>
            
            <Divider />
            
            {
              props.basket.map((item, index) => (
                <>
                  <Styled.BasketItem>
                    <Image src={`${process.env.REACT_APP_S3_FILES_URL}${item.mount.output}`} width={50} style={{ minWidth: 50 }} />

                    <Select
                      style={{ width: 55, marginLeft: 20 }}
                      value={item.quantity}
                      onChange={(quantity) => handleChangeQuantity(index, quantity)}
                    >
                      {
                        Array.from(Array(10).keys()).map((inc) => (
                          <Select.Option value={inc + 1} key={`total-selectable-item-${inc + 1}`}>{inc + 1}</Select.Option>
                        ))
                      }
                    </Select>

                    <Text 
                      size={14} 
                      style={{ marginLeft: 10, marginTop: 5 }}
                    >
                      {`${item.support.name_fr || item.support._provider_name}`}
                    </Text>

                    <Text 
                      size={15} 
                      style={{ marginLeft: 'auto', marginTop: 5 }}
                    >
                      {getPrice(item).toFixed(2)}€
                    </Text>
                    
                    <CloseOutlined 
                      style={{ cursor: 'pointer', fontSize: 14, marginTop: 7, marginLeft: 20, color: 'red' }} 
                      onClick={() => handleRemoveFromBasket(index)}
                    />
                  </Styled.BasketItem>
                  {
                    item.options.length > 0 && (
                      <div style={{ marginLeft: 10 }}>
                        {
                          item.options.filter((category) => category.selectedOption !== null).length > 0 && (
                            <>
                              <Text size={12} color="grey" style={{ borderBottom: '1px dashed lightgrey', paddingBottom: 5 }}>Options sélectionnées</Text>
                              {
                                item.options.filter((category) => category.selectedOption !== null).map((category) => (
                                  <div style={{ marginLeft: 10, display: 'flex', paddingTop: 5 }}>
                                    <Text color="grey" size={12}>{`${category.selectableOptionName} - ${category.selectedOption.name}`}</Text>

                                    <Text color="grey" style={{ marginLeft: 'auto'}} size={12}>
                                      {category.selectedOption.price > 0 ? (
                                        <>{category.selectedOption.price}€</>
                                      ) : 
                                      (
                                        <>Offert</>
                                      )}
                                    </Text>
                                  </div>
                                ))
                              }
                            </>
                          )
                        }
                      </div>
                    )
                  }
                  <Divider style={{ margin: 10 }} />
                </>
              ))
            }

            <div style={{ display: 'flex', marginBottom: 20 }}>
              <Text size={16}>Montant total TTC</Text>
              <Text size={16} style={{ marginLeft: 'auto' }} color="#176b87" >{getTotalPrice().toFixed(2)}€</Text>
            </div>

            <Button type="primary" style={{ width: '100%' }} onClick={() => props.setView('delivery')}>Etape suivante</Button>
          </div>
        )
      }
    </>
  )
}

export default withTranslation()(Basket);